module.exports = __webpack_public_path__ + "img/red-white-and-brown-gift-boxes-1303081.e7ac095d.jpg";